import { Button, Icon, Checkbox, FormControl, Grid, InputLabel, MenuItem, Paper, Select, Tab, Tabs, TextField, Typography, makeStyles, Tooltip, Box } from '@material-ui/core';
import React from 'react';
import { ITableCommonToolbar, TableCommon } from '../../../shared/components/TableCommon';
import { TableLoading } from '../../../shared/components/TableLoading';
import { BasicConfirmDialog } from '../../../shared/components/BasicConfirmDialog';
import { HomeContext } from '../../Home/HomeContext';
import { AuthContext } from '../../Authentication/AuthContext';
import { HistoryLocation } from '../enum/HistoryLocation';
import { PageLocation } from '../../../shared/enum/PageLocation';
import { NewsStatus } from '../enum/NewsStatus';
import InfluencerSpreadsheetService from '../../../Services/InfluencerService';
import { InfluencerSpreadsheetModel, InfluencerSpreadsheetModelInitial } from '../../../Models/InfluencerSpreadSheetModel';
import { AxiosError, AxiosResponse } from 'axios';
import { getTableColumn } from '../../../shared/operators';
import { Action, Column, Options } from 'material-table';
import { TableEmpty } from '../../../shared/components/TableEmpty';
import { NewsOrigin } from '../../../shared/enum/NewsOrigin';
import { theme } from '../../../theme';
import InfluencerService from '../../../Services/InfluencerService';
import { InfluencerModel } from '../../../Models/InfluencerModel';
import InfluencerClassificationFilters from '../components/InfluencerClassificationFilters';
import { useInputStyles } from '../../../shared/components/UploadStyles';
import { InfluencerAuxiliarModel, InfluencersAuxiliarResponse } from '../../../Models/InfluencerAuxiliarModel';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { ptBR } from 'date-fns/locale';
import DateFnsUtils from '@date-io/date-fns';
import { InfluencerContext } from '../../ClassificationInfluencer/NewsContext';
import InfluencerDateFilter from '../components/InfluencerDateFilter';
import InfluencerUrlFilter from '../components/InfluencerUrlFilter';
import InfluencerTextFilter from '../components/InfluencerTextFilter';
import InfluencerDetailModal from '../components/InfluencerDetailModal';
import { format } from 'date-fns';
import { TableCommonDetail } from '../../../shared/components/TableCommonDetail';
import InfluencerCampaingService from '../../../Services/InfluencerCampaingService';
import { CampaignModel } from '../../../Models/CampaignModel';
import CampaignDetailModal from '../components/CampaignDetailModal';

export interface IHistoryClassificationProps {
    handlePageLocation: (location: PageLocation) => void;
}

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(1.5, 4),
        width: '100%',
        maxWidth: '1800px'
    },
    title: {
        margin: '20px 0px 32px'
    },
    titleContainer: {
        marginBottom: theme.spacing(3)
    },
    tabs: {
        justifyContent: 'space-between',
        display: 'flex'
    },
    addNewButtonGrid: {
        justifyItems: 'center'
    },
    emptyTable: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        maxWidth: '1800px',
        padding: theme.spacing(0, 4)
    },
    whiteTooltip: {
        backgroundColor: '#fff',
        color: '#000',
        boxShadow: theme.shadows[1],
        fontSize: 12,
        maxWidth: 400,
        border: '1px solid #ccc',
    },
}));
export default function InfluencerCampaignConsult() {
    const classesInput = useInputStyles();
    const classes = useStyles();

    const authContext = React.useContext(AuthContext);
    const homeContext = React.useContext(HomeContext);
    const clientEnable = homeContext.influencerClientEnable;

    const [historyType, setHistoryType] = React.useState<HistoryLocation>(HistoryLocation.PENDING);
    const [spreadsheets, setSpreadsheets] = React.useState<InfluencerSpreadsheetModel[]>([]);

    const [filters, setFilters] = React.useState<InfluencersAuxiliarResponse>();
    const [filterDate, setFilterDate] = React.useState<Date | null>(null);
    const [filterRequestor, setFilterRequestor] = React.useState<number | null>();
    const [filterResponsavelReputacao, setFilterResponsavelReputacao] = React.useState<number | null>();
    const [filterStatus, setFilterStatus] = React.useState<number | null>();
    const [filterBrand, setFilterBrand] = React.useState<number | null>();
    const [filterArea, setFilterArea] = React.useState<number | null>();
    const [filterVp, setFilterVp] = React.useState<number | null>();
    const [filterNomeInfluenciador, setFilterNomeInfluenciador] = React.useState<string>('');
    const [filterUrl, setFilterUrl] = React.useState<string>('');
    const [filterDateReceipt, setFilterDateReceipt] = React.useState<Date | null>(null);
    const [filterDateAnalise, setFilterDateAnalise] = React.useState<Date | null>(null);
    const [filterDateDelivery, setFilterDateDelivery] = React.useState<Date | null>(null);
    const [filterInitiative, setFilterInitiative] = React.useState<number | null>();
    const [filterTerritory, setFilterTerritory] = React.useState<number | null>();
    const [filterSize, setFilterSize] = React.useState<number | null>();
    const [filterName, setFilterName] = React.useState<string>('');

    const [showConfirmDelete, setShowConfirmDelete] = React.useState(false);
    const [showDetailInfluencer, setShowDetailInfluencer] = React.useState(false);
    const [selectedInfluencer, setSelectedInfluencer] = React.useState<CampaignModel>();

    const [loading, setLoading] = React.useState(true);


    React.useEffect(() => {
        setLoading(true);
        if (clientEnable) {
            if (historyType == HistoryLocation.PENDING) {
                InfluencerCampaingService.getCampaignByClient(clientEnable.id_cliente)
                    .then((res: AxiosResponse) => { setSpreadsheetsData(res.data); })
                    .catch((error: AxiosError) => { homeContext.showError('', error); });

                InfluencerService.getInfluencersBrandByClient(clientEnable.id_cliente)
                    .then((res: AxiosResponse) => {
                        setFiltersData(res.data);
                    })
                    .catch((error: AxiosError) => { homeContext.showError('', error); });

            } else
                setLoading(false);
        }
    }, [historyType, status]);

    const setSpreadsheetsData = (data: InfluencerSpreadsheetModel[]) => {
        setSpreadsheets(data);

        if (filters !== null && spreadsheets) {
            setLoading(false);
        }
    };
    const getNivelRiscoIcon = (nivel: string) => {
        const normalized = nivel?.toLowerCase();
        switch (normalized) {
            case 'baixo':
                return (
                    <Tooltip title="Baixo: Não há registros ou sensibilidades que representem risco reputacional ao Grupo.">
                        <Box display="flex" alignItems="center">
                            <Icon style={{ color: 'green', marginRight: 4 }}>check_circle</Icon>
                            <span>Baixo</span>
                        </Box>
                    </Tooltip>
                );
            case 'moderado':
                return (
                    <Tooltip title="Moderado: Foi(ram) identificada(s) sensibilidade(s) com possível impacto reputacional ao Grupo.">
                        <Box display="flex" alignItems="center">
                            <Icon style={{ color: 'goldenrod', marginRight: 4 }}>warning</Icon>
                            <span>Moderado</span>
                        </Box>
                    </Tooltip>
                );
            case 'alto':
                return (
                    <Tooltip title="Alto: Foram identificadas sensibilidades que apresentam alto risco reputacional ao Grupo.">
                        <Box display="flex" alignItems="center">
                            <Icon style={{ color: 'red', marginRight: 4 }}>error</Icon>
                            <span>Alto</span>
                        </Box>
                    </Tooltip>
                );
            case 'crítico':
            case 'critico':
                return (
                    <Tooltip title="Crítico: Foram identificadas sensibilidades que apresentam risco reputacional severo ao Grupo. Não recomendamos a realização.">
                        <Box display="flex" alignItems="center">
                            <Icon style={{ color: 'darkred', marginRight: 4 }}>highlight_off</Icon>
                            <span>Crítico</span>
                        </Box>
                    </Tooltip>
                );
            default:
                return nivel;
        }
    };
    const setFiltersData = (data: InfluencersAuxiliarResponse) => {
        setFilters(data);
        // setLoading(false);

    };

    const tableColumns: Column<CampaignModel>[] = [
        getTableColumn('Campanha/Projeto', 'nome', 'string', 'left', undefined, undefined, false),
        getTableColumn('Marca', 'marca', 'string', 'left', undefined, undefined, false),
        {
            title: 'Validade da Análise',
            field: 'validadeAnalise',
            type: 'string',
            align: 'left',
            cellStyle: {
                maxWidth: 190,
                overflowWrap: 'break-word',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflow: 'hidden'
            },
            headerStyle: {
                maxWidth: 190,
                whiteSpace: 'normal',
                overflowWrap: 'break-word',
                textAlign: 'left'
            },
            render: (rowData: CampaignModel) =>
                rowData.validadeAnalise
                    ? format(new Date(rowData.validadeAnalise), 'dd/MM/yyyy')
                    : '-'
        },
        getTableColumn('Nome Solicitante', 'solicitante', 'string', 'left', undefined, undefined, false),
        {
            title: (
                <Tooltip
                    title={
                        <div style={{ lineHeight: 1.6 }}>
                            <div><Icon style={{ color: 'green', fontSize: 16, verticalAlign: 'middle' }}>check_circle</Icon> <b>Baixo</b>: Não há registros ou sensibilidades que representem risco reputacional ao Grupo.</div>
                            <div><Icon style={{ color: 'goldenrod', fontSize: 16, verticalAlign: 'middle' }}>warning</Icon> <b>Moderado</b>: Sensibilidade(s) com possível impacto reputacional ao Grupo.</div>
                            <div><Icon style={{ color: 'red', fontSize: 16, verticalAlign: 'middle' }}>error</Icon> <b>Alto</b>: Sensibilidades que apresentam alto risco reputacional.</div>
                            <div><Icon style={{ color: 'darkred', fontSize: 16, verticalAlign: 'middle' }}>highlight_off</Icon> <b>Crítico</b>: Risco reputacional severo. Não recomendamos a realização.</div>
                        </div>
                    }
                    arrow
                    placement="top"
                    classes={{ tooltip: classes.whiteTooltip }}
                >
                    <span>Nível de Risco</span>
                </Tooltip>
            ),
            field: 'nivelRisco',
            type: 'string',
            align: 'left',
            filtering: false,
            cellStyle: { whiteSpace: 'nowrap' },
            render: (rowData: CampaignModel) => getNivelRiscoIcon(rowData.nivelRisco)
        },
        {
            title: 'Data Submissão',
            field: 'dataRecebimento',
            type: 'string',
            align: 'left',
            defaultSort: 'desc',
            cellStyle: {
                maxWidth: 190,
                overflowWrap: 'break-word',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflow: 'hidden'
            },
            headerStyle: {
                maxWidth: 190,
                whiteSpace: 'normal',
                overflowWrap: 'break-word',
                textAlign: 'left'
            },
            render: (rowData: CampaignModel) =>
                rowData.dataRecebimento
                    ? format(new Date(rowData.dataRecebimento), 'dd/MM/yyyy')
                    : '-'
        },
    ];

    const pendingTableToolbarText: ITableCommonToolbar = {
        title: '   ',
        subtitle: ' '
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const pendingTableActions: (Action<any> | ((rowData: any) => Action<any>))[] = [
        {
            icon: 'addCircle',
            iconProps: { style: { fontSize: '20px' } },
            tooltip: 'Detalhes',
            onClick: (_, rowData: CampaignModel) => {
                setShowDetailInfluencer(true);
                setSelectedInfluencer(rowData);
            }
        },

    ];
    const pendingTableOptions: Options<CampaignModel> = {
        filtering: true,
        actionsColumnIndex: -1,
        pageSizeOptions: [5, 10],
    };




    const setFilterNull = () => {
        setFilterUndefined();
        setFilterDateReceipt(null);
        setFilterDateAnalise(null);
        setFilterDateDelivery(null);

        setFilterUrl('');
        setFilterName('');

        setFilterDate(null);
        setFilterRequestor(undefined);
        setFilterStatus(undefined);
        setFilterBrand(undefined);
        setFilterArea(undefined);
        setFilterVp(undefined);
        setFilterResponsavelReputacao(undefined);
        setFilterNomeInfluenciador('');
        setFilterUrl('');

        setLoading(true);
        if (clientEnable) {
            InfluencerCampaingService.getCampaignByClient(clientEnable.id_cliente)
                .then((res: AxiosResponse) => { setSpreadsheetsData(res.data); })
                .catch((error: AxiosError) => { homeContext.showError('', error); });
        }
    };
    const setFilterUndefined = () => {
        setFilterRequestor(undefined);
        setFilterStatus(undefined);
        setFilterBrand(undefined);
        setFilterInitiative(undefined);
        setFilterTerritory(undefined);
        setFilterSize(undefined);
        setFilterArea(undefined);
    };

    const getEmptyTable = (historyLocation: HistoryLocation, displayText: string) => {
        if (historyType == historyLocation && spreadsheets.length == 0 && !loading) {
            return (
                <Grid
                    container
                    spacing={3}
                    direction="column"
                    alignItems="center">
                    <Grid item className={classes.emptyTable}>
                        <TableEmpty displayText={displayText} />
                    </Grid>

                </Grid>
            );
        }
    };

    const getFiltersInfluencers = () => {
        setLoading(true);
        if (clientEnable) {
            InfluencerCampaingService.getCampaignByClient(clientEnable.id_cliente,
                {
                    data_hora_receipt: filterDate,
                    marca: filterBrand,
                    solicitante: filterRequestor,
                    area: filterArea,
                    responsavel_reputacao: filterResponsavelReputacao,
                    nome: filterNomeInfluenciador,
                    url: filterUrl,
                    vp: filterVp,
                }
            )
                .then((res: AxiosResponse) => {
                    if (res.data.length == 0) {
                        setSpreadsheetsData([]);
                    }
                    else {
                        setSpreadsheetsData(res.data);
                    }
                    setSpreadsheetsData(res.data);
                })
                .catch((error: AxiosError) => { homeContext.showError('', error); });
        }
    };

    const inputTitleAndSubtitle = () => {
        return (
            <Grid
                container
                spacing={1}
                className={classes.titleContainer}
            >
                <Grid
                    item
                    xs={12}
                >
                    <Typography variant="h4">
                        Consulta de Campanhas e Projetos
                    </Typography>
                </Grid>
            </Grid>
        );
    };
    return (
        <>
            <Grid container justify="center">
                <Grid
                    container
                    className={classes.root}
                    justify="flex-start"
                    direction="column">
                    <Grid container
                        direction="row"
                        className={classes.root}
                        alignItems="center">
                        {inputTitleAndSubtitle()}
                    </Grid>
                    {filters && (
                        <Grid
                            container
                            className={classes.root}
                            direction="column"
                        >
                            <Paper
                                style={{
                                    borderRadius: '8px',
                                    width: '100%',
                                    // overflowX: 'auto'
                                }}
                            >
                                <Grid
                                    container
                                    direction="row"
                                    className={classes.root}
                                    spacing={3}
                                >

                                    <InfluencerClassificationFilters size={3} key={filterResponsavelReputacao} items={filters.responsavel_reputacao}
                                        Title={'Responsável Reputação'} selectValue={filterResponsavelReputacao} setSelectValue={setFilterResponsavelReputacao} />
                                    <InfluencerTextFilter size={3} titulo='Nome da empresa ou evento' value={filterNomeInfluenciador} setValue={setFilterNomeInfluenciador} />
                                    <InfluencerClassificationFilters size={3} key={filterRequestor} items={filters.solicitantes} Title={'Nome Solicitante'} selectValue={filterRequestor} setSelectValue={setFilterRequestor} />
                                    <InfluencerClassificationFilters size={3} key={filterVp} items={filters.vp} Title={'VP'} selectValue={filterVp} setSelectValue={setFilterVp} />
                                    <Grid item
                                    >
                                        <InfluencerDateFilter filterDate={filterDateReceipt}
                                            setFilterDate={setFilterDateReceipt}
                                            titulo="Data de Recebimento" />
                                    </Grid>
                                    <InfluencerClassificationFilters items={filters.marcas} Title={'Marca'} selectValue={filterBrand} setSelectValue={setFilterBrand} />
                                    <InfluencerClassificationFilters items={filters.area} Title={'Área'} selectValue={filterArea} setSelectValue={setFilterArea} />
                                </Grid>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="flex-end"
                                >
                                    <Button
                                        size="large"
                                        variant="contained"
                                        color="inherit"
                                        style={{
                                            width: '180px',
                                            margin: '20px',
                                        }}
                                        onClick={setFilterNull}
                                    >
                                        Limpar Filtros
                                    </Button>

                                    <Button
                                        size="large"
                                        variant="contained"
                                        color="primary"
                                        style={{
                                            width: '180px',
                                            margin: '20px',
                                        }}
                                        onClick={getFiltersInfluencers}
                                    >Buscar</Button>
                                </Grid>
                            </Paper>
                        </Grid>
                    )}
                    {spreadsheets.length > 0 && !loading && (
                        <>
                            <Grid
                                container
                                className={classes.root}
                                direction="column"
                            >
                                <TableCommon
                                    tableData={spreadsheets}
                                    tableColumns={tableColumns}
                                    emptyDataSourceMessage='Nenhuma Empresa encontrada para esse filtro.'
                                    tableActions={pendingTableActions}
                                    tableActionsName='Detalhe'
                                    toolbar={pendingTableToolbarText}
                                    style={{ padding: theme.spacing(0, 11) }} />
                            </Grid>
                        </>

                    )}
                    {loading &&
                        <TableLoading displayText="Carregando histórico" />}

                    {!loading && getEmptyTable(HistoryLocation.PENDING, 'Nenhum influenciador encontrado.')}
                </Grid >
            </Grid >

            {/* {newsContext.newsCurrentId && ( */}
            <CampaignDetailModal
                open={showDetailInfluencer}
                onClose={() => setShowDetailInfluencer(false)
                }
                influencer={selectedInfluencer}
                filters={filters}
            />
            {/* )} */}
        </>
    );
}